import Icon from '@/components/ui/AppIcon';

interface SocialPost {
  id: string;
  platform: string;
  content: string;
  timestamp: string;
  engagement: {
    likes: number;
    shares: number;
    comments: number;
  };
}

interface SocialMediaFeedProps {
  posts: SocialPost[];
}

export default function SocialMediaFeed({ posts }: SocialMediaFeedProps) {
  const getPlatformIcon = (platform: string) => {
    switch (platform.toLowerCase()) {
      case 'twitter':
        return 'ChatBubbleLeftRightIcon';
      case 'facebook':
        return 'UserGroupIcon';
      case 'instagram':
        return 'CameraIcon';
      default:
        return 'GlobeAltIcon';
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-organic-sm p-6 border border-border">
      <h3 className="text-lg font-headline font-bold text-foreground mb-4 flex items-center space-x-2">
        <Icon name="ChatBubbleLeftRightIcon" size={20} variant="outline" />
        <span>Social Media Updates</span>
      </h3>
      
      <div className="space-y-4">
        {posts.map((post) => (
          <div
            key={post.id}
            className="p-4 bg-muted rounded-lg border border-border hover:border-primary/30 transition-organic duration-300"
          >
            <div className="flex items-start space-x-3 mb-3">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center">
                <Icon name={getPlatformIcon(post.platform) as any} size={20} variant="solid" className="text-primary" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-body font-semibold text-foreground">{post.platform}</span>
                  <span className="text-xs text-muted-foreground font-body">{post.timestamp}</span>
                </div>
                <p className="text-sm text-foreground font-body leading-relaxed">
                  {post.content}
                </p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4 text-xs text-muted-foreground font-body pt-3 border-t border-border">
              <div className="flex items-center space-x-1">
                <Icon name="HeartIcon" size={14} variant="outline" />
                <span>{post.engagement.likes}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="ArrowPathRoundedSquareIcon" size={14} variant="outline" />
                <span>{post.engagement.shares}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="ChatBubbleLeftIcon" size={14} variant="outline" />
                <span>{post.engagement.comments}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <button className="w-full mt-4 px-4 py-2 bg-primary text-primary-foreground font-cta text-sm font-semibold rounded-md hover:bg-primary/90 transition-organic duration-300 flex items-center justify-center space-x-2">
        <span>View All Posts</span>
        <Icon name="ArrowRightIcon" size={16} variant="outline" />
      </button>
    </div>
  );
}